import { DefaultState } from 'store/types';

export const GET_LODGING_REQUESTS_COUNT_DATA_REQUEST = 'GET_LODGING_REQUEST_COUNT_DATA_REQUEST';
export const GET_LODGING_REQUESTS_COUNT_DATA_SUCCESS = 'GET_LODGING_REQUEST_COUNT_DATA_SUCCESS';
export const GET_LODGING_REQUESTS_COUNT_DATA_FAILURE = 'GET_LODGING_REQUEST_COUNT_DATA_FAILURE';

export interface GetLodgingRequestsCountData {
  open: number;
  pending: number;
  draft: number;
  completed: number;
  canceled: number;
}

export type GetLodgingRequestsCountState = DefaultState & {
  contents?: GetLodgingRequestsCountData;
};

interface ReadGetLodgingRequestsCountDataRequest {
  type: typeof GET_LODGING_REQUESTS_COUNT_DATA_REQUEST;
};

interface ReadGetLodgingRequestsCountDataSuccess {
  type: typeof GET_LODGING_REQUESTS_COUNT_DATA_SUCCESS,
  contents: GetLodgingRequestsCountData;
}

interface ReadGetLodgingRequestsCountDataFailure {
  type: typeof GET_LODGING_REQUESTS_COUNT_DATA_FAILURE;
}

export type GetLodgingRequestsCountActionTypes = ReadGetLodgingRequestsCountDataRequest | ReadGetLodgingRequestsCountDataSuccess | ReadGetLodgingRequestsCountDataFailure;